import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemStateNotice extends Cloneable {
    static NONE = new ItemStateNotice(0, "NONE");

    static _values = [
        ItemStateNotice.NONE,
        new ItemStateNotice(1, "HAND"),
        new ItemStateNotice(2, "PICK"),
        new ItemStateNotice(3, "SHOVEL"),
        new ItemStateNotice(4, "HAMMER"),
        new ItemStateNotice(5, "PET"),
        new ItemStateNotice(6, "CHEST")
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemStateNotice.getValue(id));
        });
    }

    static getValues() {
        return ItemStateNotice._values;
    }

    static getValue(id) {
        let value = ItemStateNotice._values.find(v => v.id === id) || null;
        console.assert(value, "unknown action id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ItemStateNotice) {
            return ItemStateNotice._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return ItemStateNotice.NONE.equal(value);
    }

    constructor(id = 0, name = "None") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ItemStateNotice) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemStateNotice());
        } else if (target instanceof ItemStateNotice) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemStateNotice, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});